/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */

// Note, overriding formatting options for eslint prettier for this file, to same as cloud-pal-community
// https://github.ibm.com/ibmcloud/cloud-pal-community/blob/41d9e5ec25db30078d6c14d5a89fcd4cc0ee63c3/prettier.config.js
/* eslint prettier/prettier: ["error", { jsxBracketSameLine: true, printWidth: 80, singleQuote: true, proseWrap: 'always', arrowParens: 'avoid', }] */

/*
Configs are controlled here. The config is used to generate a data hook API call. It can be used for other types of API calls as well
*/
var config = {
  name: 'usePartialToolData',
  // REQUIRED Name of the data hook, should be the same as the file name.
  type: 'retrieve',
  // REQUIRED Data Hook type, currently retrieve or modify
  uri: '/devops/api/v1/secrets',
  // REQUIRED URL that will be called with this request
  method: 'GET',
  documentation: {
    params: {}
  }
};
export default config;